import { useNavigate } from "react-router";

import { UnderlineTab } from "./underline-tab";

const SECTIONS = [
  { id: "suppliers", label: "Suppliers", href: "/spend-centre" },
  { id: "reports", label: "Reports", href: "/spend-centre/reports" },
] as const;

interface Props {
  active: (typeof SECTIONS)[number]["id"];
}

export const SpendCentreTabs = ({ active }: Props) => {
  const navigate = useNavigate();
  return (
    <nav aria-label="Spend Centre sections" className="mt-5 flex gap-1 border-b border-spend-divider">
      {SECTIONS.map(section => (
        <UnderlineTab
          key={section.id}
          active={section.id === active}
          aria-current={section.id === active ? "page" : undefined}
          onClick={() => section.id !== active && navigate(section.href)}
        >
          {section.label}
        </UnderlineTab>
      ))}
    </nav>
  );
};
